$(function (){

    

    // our collection slider
    $('.our-collection-slider').slick({   
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true, 
        dots: false,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        mobileFirst: true,
        prevArrow: $('.collection-arrow.arrow-prev'),
        nextArrow: $('.collection-arrow.arrow-next'),
        responsive: [
        {
            breakpoint: 767,
            settings: 'unslick'
        },
        ]
    });
    $(window).on('resize', function() {
        $('.our-collection-slider').slick('resize');
    });
    // end our collection slider

    // announcement slider
    // $(".announcement-bar ul").slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     autoplay: true,
    //     autoplaySpeed: 0,
    //     speed: 5000,
    //     pauseOnHover: false,
    //     cssEase: 'linear',
    //     arrows: false,
    //     variableWidth: true,
    //     mobileFirst: true,
    //     responsive: [
    //         {
    //             breakpoint: 767,
    //             settings: 'unslick'
    //         },
    //     ]
    // });
    // $(window).on('resize', function() {
    //     $('.announcement-bar ul').slick('resize');
    // });
    // end announcement slider

    // hamburg-icon click menu open
    $(".hamburg-icon").click(function (){
        $(this).toggleClass("hamburg-open");
        $(".header__nav > ul").slideToggle();
    });
    $("body").on("click", "li.dropdown", function (){        
        $(this).toggleClass("open-dropdown");       
        $(".header__nav > ul li.dropdown > ul").slideToggle();
    });
    // end hamburg-icon click menu open

    // load more data
    let getwindowsize = $(window).width();
    if(getwindowsize < 992){

        $(".our-collection--page .our-collection__cols, .filter-menu__right .filter-menu__items, .blog--page .container .row:nth-child(2) .blog__cols").slice(0, 4).show();

        $(".load-more-data").on('click', function (e) {
            e.preventDefault();
            $(".our-collection--page .our-collection__cols:hidden, .filter-menu__right .filter-menu__items:hidden, .blog--page .container .row:nth-child(2) .blog__cols:hidden").slice(0, 4).slideDown();
            if ($(".our-collection--page .our-collection__cols:hidden, .filter-menu__right .filter-menu__items:hidden, .blog--page .container .row:nth-child(2) .blog__cols:hidden").length == 0) {
                $(".load-more-data").fadeOut('slow');
                $(".our-collection.our-collection--page .container > .row, .filter-menu__right .row, .blog--page .container .row:nth-child(2)").addClass("load-more-data-remove");
            }
        });
    }
    // end load more data

    // slider cart open 
    $(".cart-icon").click(function () {
        $(".slide-cart").addClass("open-slide-cart");
        $("body").addClass("opacity-body");
        $("html").addClass("hide-scroll-body");
    });
    $(".slide-cart-close").click(function () {
        $(".slide-cart").removeClass("open-slide-cart");
        $("body").removeClass("opacity-body");
        $("html").removeClass("hide-scroll-body");
    });
    // end slider cart open 

    // browser safari add class
    if (navigator.userAgent.indexOf('Mac OS X') != -1) {
        $('body').addClass('browser-safari');
    }
    // end browser safari add class

    // subscription root above container div add
    $("#manage-subscription-root").wrap("<div class='container'></div>")
    // end subscription root above container div add

    // Subscribe & Save! label set
    $(".product-detail__right .ro_widget > div:first-child .bold-ro__radio-div:last-child input").attr("checked", "true");
   
    setTimeout(function() {
        $(".bold-ro__one-time-purchase").html("One Time Purchase");
        $(".product-detail__right .ro_widget > div:first-child .bold-ro__radio-div:last-child input").click();
    }, 1500);
    // end Subscribe & Save! label set

    // blog page share link copy link
    $(".share-button__fallback .share-button__copy").click(function (e) {
        e.preventDefault();
        var text = $("#ShareUrl-template--14833453432868__main").select();
        document.execCommand('copy'); 
    });
    // end blog page share link copy link

    //  &nbsp blank tag remove 
    $('p').each(function() {
        var $this = $(this);
        if($this.html().replace(/\s|&nbsp;/g, '').length == 0){
            $this.remove(); 
        }
    });
    //  end &nbsp blank tag remove 

    // sticky button in footer
    // function isOnScreen(s) {
    //     if (s.length != 0) {
    //         var e = jQuery(window),
    //             t = e.scrollTop(),
    //             o = e.height(),
    //             l = t + o,
    //             n = jQuery(s),
    //             i = n.offset().top,
    //             r = n.height(),
    //             a = i + r;
    //         return (i >= t && i < l) || (a > t && a <= l) || (r > o && i <= t && a >= l);
    //     }
    // }
      
    // isOnScreen($(".non-sticky-atc-button").eq(0)) ||
    // isOnScreen($(".non-sticky-atc-button").eq(1)) ||
    // isOnScreen($(".non-sticky-atc-button").eq(2)) ||
    // isOnScreen($(".non-sticky-atc-button").eq(3)) ||
    // isOnScreen($(".non-sticky-atc-button").eq(4)) ||
    // isOnScreen($(".non-sticky-atc-button").eq(5)) ||
    // isOnScreen($(".non-sticky-atc-button").eq(6)) ||
    // isOnScreen($(".non-sticky-atc-button").eq(7)) ||
    // isOnScreen($(".non-sticky-atc-button").eq(8)) ||
  
    // isOnScreen($("footer"))
    //     ? $(".sticky-atc-button").fadeOut(100)
    //     : $(".sticky-atc-button").fadeIn(100),
    // $(window).on("scroll", function () {
    //     isOnScreen($(".non-sticky-atc-button").eq(0)) ||
    //     isOnScreen($(".non-sticky-atc-button").eq(1)) ||
    //     isOnScreen($(".non-sticky-atc-button").eq(2)) ||
    //     isOnScreen($(".non-sticky-atc-button").eq(3)) ||
    //     isOnScreen($(".non-sticky-atc-button").eq(4)) ||
    //     isOnScreen($(".non-sticky-atc-button").eq(5)) ||
    //     isOnScreen($(".non-sticky-atc-button").eq(6)) ||
    //     isOnScreen($(".non-sticky-atc-button").eq(7)) ||
    //     isOnScreen($(".non-sticky-atc-button").eq(8)) ||

    //     isOnScreen($("footer"))
    //         ? $(".sticky-atc-button").fadeOut(10)
    //         : $(".sticky-atc-button").fadeIn(10);
    // });
    // sticky button in footer
  
});

